import { render, staticRenderFns } from "./LeasesTabs.vue?vue&type=template&id=5e48f4c2&scoped=true"
import script from "./LeasesTabs.vue?vue&type=script&lang=js"
export * from "./LeasesTabs.vue?vue&type=script&lang=js"
import style0 from "./LeasesTabs.vue?vue&type=style&index=0&id=5e48f4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48f4c2",
  null
  
)

export default component.exports